import type { z } from "zod";
import type { ErrorCode } from "./errors.js";

export type Permission =
  | "tenant.read"
  | "tenant.admin"
  | "credential.manage"
  | "project.read"
  | "project.write"
  | "agent.read"
  | "agent.control"
  | "agent.fs.write"
  | "agent.terminal"
  | "approval.decide"
  | "conversation.write"
  | "task.write"
  | "code.review"
  | "code.merge"
  | "asset.write"
  | "billing.manage"
  | "market.publish"
  | "platform.admin"
  | "capability.manage"
  | "secret.manage";

export interface RouteDef {
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  path: string;
  summary: string;
  tags: string[];
  auth: "public" | "user";
  /** 需要的权限；scope 由 path 中的 :tid / :pid / :aid 决定 */
  permission?: Permission;
  params?: z.ZodObject;
  query?: z.ZodObject;
  body?: z.ZodType;
  response: z.ZodType;
  /** 该接口可能返回的业务错误码（通用错误不列） */
  errors?: ErrorCode[];
  /** 创建类接口支持 Idempotency-Key */
  idempotent?: boolean;
  /** 所属开发阶段（doc/dev_plan.md §4）；缺省 1。控制面只注册 phase ≤ ENABLED_PHASE 的路由 */
  phase?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
}

export const r = <const T extends RouteDef>(def: T) => def;
